// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => (
  <footer className="optech-footer-section">
    <div className="container">
      <div className="optech-footer-top pt-5 pb-5">
        <div className="row">
          {/* Logo & About */}
          <div className="col-xl-4 col-lg-12">
            <div className="optech-footer-textarea dark-color">
              <NavLink to="/">
                <img
                  src="/assets/images/logo/ra-logo.png"
                  width="200px"
                  alt="R.A. Inc. Logo"
                />
              </NavLink>
              <p>
                Our commitment to quality, confidentiality, and timely delivery
                makes us a trusted partner for organizations seeking precise,
                industry-aligned communication worldwide.
              </p>
              <div className="optech-social-icon-box style-two">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="ri-facebook-fill" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="ri-linkedin-fill" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="ri-twitter-fill" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="ri-instagram-fill" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-xl-2 offset-xl-1 col-md-4">
            <div className="optech-footer-menu dark-color">
              <div className="optech-footer-title dark-color">
                <h5>Quick Links</h5>
              </div>
              <ul>
                <li><NavLink to="/">Home</NavLink></li>
                <li><NavLink to="/about-us">About Us</NavLink></li>
                <li><NavLink to="/translation">Translation</NavLink></li>
                <li><NavLink to="/faq">FAQ</NavLink></li>
                <li><NavLink to="/languages">Languages</NavLink></li>
                <li><NavLink to="/industry">Industry</NavLink></li>
                <li><NavLink to="/contact-us">Contact Us</NavLink></li>
              </ul>
            </div>
          </div>

          {/* AI Services */}
          <div className="col-xl-3 col-md-5">
            <div className="optech-footer-menu dark-color ml30">
              <div className="optech-footer-title dark-color">
                <h5>AI Services</h5>
              </div>
              <ul>
                <li><NavLink to="/data-annotation-services">Data Annotation Services</NavLink></li>
                <li><NavLink to="/chat-prompt-optimization">Chat Prompt Optimization</NavLink></li>
                <li><NavLink to="/image-processing-and-labeling">Image Processing & Labeling</NavLink></li>
                <li><NavLink to="/chatbot-training-and-testing">AI – Chatbot Training & Testing</NavLink></li>
                <li><NavLink to="/image-localization-editing-and-retouching">Image Localization, Editing & Retouching</NavLink></li>
                <li><NavLink to="/immersive-technologies">Immersive Technologies</NavLink></li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-xl-2 col-md-3">
            <div className="optech-footer-menu dark-color mb-0">
              <div className="optech-footer-title dark-color">
                <h5>Contact Info.</h5>
              </div>
              <ul>
                <li>
                  <a
                    href="https://maps.app.goo.gl/GwZrttRT2a3jorgGA"
                    target="_blank"
                    rel="noreferrer"
                  >
                    2nd floor, Haridwar Bypass Rd, Dehradun, India, 248001
                  </a>
                </li>
                <li>
                  <a href="mailto:pm@raincorporated.com">
                    pm@raincorporated.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="optech-footer-bottom center one">
        <div className="optech-copywright dark-color">
          <p>Copyright © 2025 R.A. Inc All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;